import React from "react";
import "./totalOtcPayment.css";

const TotalOtcPayment = ({ totalAmount, onConfirmCliked }) => {
  const confirmTransaction = () => {
    onConfirmCliked();
  };

  const formatToIDR = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    })
      .format(number)
      .replace(/\D00(?=\D*$)/, ""); // remove decimals
  };
  return (
    <div className="total-transaction-otc-container">
      <div className="total-transaction-otc-information">
        <p className="total-transaction-otc-title">Total Bayar</p>
        <h3 className="total-price-transaction-otc">
          {formatToIDR(totalAmount)}
        </h3>
      </div>
      <div>
        <button
          className="confirm-otc-transaction-button"
          type="button"
          onClick={confirmTransaction}
        >
          KONFIRMASI TRANSAKSI
        </button>
      </div>
    </div>
  );
};

export default TotalOtcPayment;
